/* eslint-disable import/prefer-default-export */
import React from "react";
import { startCase } from "lodash";
import { Box, Tab, Tabs } from "@mui/material";

import Panel from "../../../../components/Panel";
import { CtcList } from "./CtcSettings/CtcList";
import SettingsButton from "../../../../components/SettingsButton/SettingsButton";
import { GeneralPayrollSettings } from "./GeneralPayrollSettings/GeneralPayrollSettings";

const TABS = {
  CTC_SETTINGS: "ctcSettings",
  GENERAL_PAYROLL_STTINGS: "generalPayrollSettings"
};

interface Props {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  renderSettingButton?: boolean;
}

export const PayrollSettingsPanel = ({
  open,
  onOpenChange,
  renderSettingButton = true
}: Props): React.ReactNode => {
  const [internalOpen, setInternalOpen] = React.useState(false);
  const [selectedTab, setSelectedTab] = React.useState(TABS.CTC_SETTINGS);

  const isControlled = typeof open === "boolean";
  const actualOpen = isControlled ? open : internalOpen;

  const setOpen = (value: boolean): void => {
    if (isControlled) {
      onOpenChange?.(value);
    } else {
      setInternalOpen(value);
    }
  };

  return (
    <>
      {renderSettingButton && <SettingsButton onClick={() => setOpen(!actualOpen)} />}

      {actualOpen && (
        <Panel
          onClose={() => setOpen(false)}
          title="Payroll Settings"
          contentStyle={{ py: 0, height: "calc(100vh - 50px)" }}
          wrapperStyle={{
            width: "calc(100vw - 80px)",
            maxWidth: "calc(100vw - 80px)"
          }}
        >
          <Box sx={{ height: "100%", borderLeft: 1, borderRight: 1, borderColor: "divider" }}>
            <Tabs
              value={selectedTab}
              onChange={(_, newValue) => setSelectedTab(newValue)}
              sx={{
                height: "50px",
                borderBottom: 1,
                borderColor: "divider"
              }}
            >
              <Tab label={startCase(TABS.CTC_SETTINGS)} value={TABS.CTC_SETTINGS} />
              <Tab
                label={startCase(TABS.GENERAL_PAYROLL_STTINGS)}
                value={TABS.GENERAL_PAYROLL_STTINGS}
              />
            </Tabs>

            <Box sx={{ height: "calc(100vh - 100px)", overflowY: "auto" }}>
              {selectedTab === TABS.CTC_SETTINGS && <CtcList />}
              {selectedTab === TABS.GENERAL_PAYROLL_STTINGS && <GeneralPayrollSettings />}
            </Box>
          </Box>
        </Panel>
      )}
    </>
  );
};
